import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Settings, AppSettings } from './app.settings';
import { Router, NavigationEnd } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { SitesService } from './admin/1.tv/sites/sites.service';
import { environment } from 'src/environments/environment';
import { CompaniesService } from './admin/1.tv/companies/companies.service';
import { ProductGroupsService } from './admin/1.tv/product-groups/product-groups.service';
import { ProductsService } from './admin/1.tv/products/products.service';
import { UserService } from './services/user.service';
import { StripeResponseService } from './services/stripe-response.service';
import { User } from './admin/1.tv/models/user.model';
import { UrlParamsService } from './services/url-params.service';
import { UsersService } from './admin/1.tv/users/users.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public loggedInUser: any;
  public settings: Settings;
  public companyId: string;
  public siteId: string;


  constructor(
    private stripeResponseService: StripeResponseService,
    private companiesService: CompaniesService,
    private sitesService: SitesService,
    private usersService: UsersService,
    private productGroupsService: ProductGroupsService,
    private productsService: ProductsService,
    public appSettings: AppSettings,
    public router: Router,
    private urlParamsService: UrlParamsService,
    @Inject(PLATFORM_ID)
    private platformId: Object,
    public translate: TranslateService,
    private userService: UserService) {
    this.settings = this.appSettings.settings;
    translate.addLangs(['en', 'de', 'fr', 'ru', 'tr', 'es']);
    translate.setDefaultLang('en');
    translate.use('en');

    // this.companyId  = "000001";
    // this.siteId     = "0000001";






    if (this.companyId === null || this.companyId === undefined) {
      this.companyId = this.urlParamsService.getQueryParamsCompanyId();
    }

    if (this.siteId === null || this.siteId === undefined) {
      this.siteId = this.urlParamsService.getQueryParamsSiteId();
    }


    // (this.companyId !== null) ? this.companyId = ('0000000' + this.companyId).slice(-6) : null;
    // (this.siteId !== null) ? this.siteId = this.companyId + '-' + ('0000000' + this.siteId).slice(-7) : null;

    this.stripeResponseService.companyId = this.companyId;
    this.stripeResponseService.siteId = this.siteId;

    this.companiesService.getCompaniesByCompanyId(stripeResponseService.companyId);
    this.sitesService.getSitesByCompanyId(stripeResponseService.companyId);
    // this.sitesService.getSitesByCompanyIdSiteId(environment.companyId, environment.siteId);
    this.productGroupsService.getProductGroupsByCompanyId(stripeResponseService.companyId);
    this.productsService.getProductsByCompanyId(stripeResponseService.companyId);
    this.usersService.getUsersByCompanyId(stripeResponseService.companyId);

    // this.companiesService.getCompanies();



    stripeResponseService.messageLoginPlus.subscribe((message) => {
      console.log('stripeResponseService app', message);
      this.userService.getUsersById$(message.userData.uid)
        .subscribe((user) => {
          console.log('user in app...', user);
          this.loggedInUser = user;
          stripeResponseService.setLoginReturnMessage(user);
        });

    });

    stripeResponseService.messageLogoutPlus.subscribe((message) => {
      console.log('stripeResponseService app messageLogoutPlus', message);
      stripeResponseService.setLogoutReturnMessage(message);
    });

  }

  ngOnInit() {

    if (this.siteId !== null && this.companyId !== null) {
      this.router.navigate(['/']);
    } else if (this.companyId !== null && this.siteId === null) {
      this.router.navigate(['/search-sites']);
    } else {
      this.router.navigate(['/search-companies']);
    }

  }
  ngAfterViewInit() {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          if (isPlatformBrowser(this.platformId)) {
            window.scrollTo(0, 0);
          }
        });
      }
    });

    const rememberMe = window.localStorage.getItem('re1');
    if (rememberMe !== null) {
      this.userService.getUsersById$(rememberMe)
        .subscribe((user) => {
          this.stripeResponseService.setLoginReturnMessage(user);
        });
    }
  }



}
